var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Dashboard"}},[_c('SideMenu'),_c('div',{staticClass:"content_sections"},[_c('Sections',{attrs:{"option":'Default'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }